import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import {
  FooterBox,
  StyledPaper,
  StyledTableCellBody,
  StyledTableCellHead,
  StyledTableFooter,
  StyledTableHead,
} from "./style";
import ShippingPartnerActions from "./ShippingPartnerActions";

const CommonTable = ({
  columns = [],
  rows = [],
  tabLabel = "",
  setEditRecord,
  setDeleteRecord,
  setDeleteConfirmOpen,
  getShippingPartnerList,
  noDataMessage = "No records found",
}) => {
  return (
    <StyledPaper tabLabel={tabLabel}>
      <TableContainer>
        <Table>
          <StyledTableHead tabLabel={tabLabel}>
            <TableRow>
              {columns.map((col) => (
                <StyledTableCellHead key={col.key}>
                  {col.label}
                </StyledTableCellHead>
              ))}
            </TableRow>
          </StyledTableHead>

          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <TableRow key={row.id || idx}>
                  {columns.map((col) => {
                    if (col.key.toLowerCase() === "actions") {
                      return (
                        <TableCell key={col.key}>
                          <ShippingPartnerActions
                            row={row}
                            setDeleteRecord={setDeleteRecord}
                            setEditRecord={setEditRecord}
                            setDeleteConfirmOpen={setDeleteConfirmOpen}
                            getShippingPartnerList={getShippingPartnerList}
                          />
                        </TableCell>
                      );
                    }
                    return (
                      <StyledTableCellBody key={col.key}>
                      {row[col.key] !== undefined && row[col.key] !== null
                        ? row[col.key]
                        : "-"}
                    </StyledTableCellBody>
                    
                    );
                  })}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Typography>{noDataMessage}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <FooterBox>
      <StyledTableFooter variant="body2">Showing {rows.length} results</StyledTableFooter>
      </FooterBox>
    </StyledPaper>
  );
};

export default CommonTable;
